var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import { layoutSizes } from "../../../constants/css";
import { PlusSign } from "../../Favourites/NoFavourites";
import Card from "./Card";
var Wrapper = styled.div.withConfig({
  displayName: "List__Wrapper",
  componentId: "sc-1hgi6c8-0"
})(["width:100%;display:grid;grid-gap:10px;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));@media only screen and (min-width:", "){grid-gap:20px;grid-template-columns:repeat(auto-fill,minmax(209px,1fr));}", ""], layoutSizes.desktopWidth, function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && "\n    display: block;\n  ";
});
var MerchantList = function MerchantList(_ref2) {
  var _ref2$merchants = _ref2.merchants,
    merchants = _ref2$merchants === void 0 ? [] : _ref2$merchants,
    _ref2$bonusRibbons = _ref2.bonusRibbons,
    bonusRibbons = _ref2$bonusRibbons === void 0 ? [] : _ref2$bonusRibbons,
    _ref2$skipMerchantPag = _ref2.skipMerchantPage,
    skipMerchantPage = _ref2$skipMerchantPag === void 0 ? false : _ref2$skipMerchantPag,
    _ref2$plusSign = _ref2.plusSign,
    plusSign = _ref2$plusSign === void 0 ? false : _ref2$plusSign,
    _ref2$isMobile = _ref2.isMobile,
    isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile;
  return __jsx(Wrapper, {
    isMobile: isMobile
  }, isMobile === false && plusSign && __jsx(PlusSign, null), merchants.map(function (merchant) {
    return __jsx(Card, {
      merchant: merchant,
      bonusRibbons: bonusRibbons,
      key: merchant.merchantId,
      skipMerchantPage: skipMerchantPage,
      isCircleHeart: true,
      isMobile: isMobile
    });
  }));
};
export default MerchantList;